export default "__VITE_ASSET__D$wZiu0h__"